const BrokerAmendmentEntryPage = () => import('~/pages/broker-portal/BrokerAmendmentEntry');
const BrokerDashboard = () => import('~/pages/broker-portal/BrokerDashboard');
const BrokerRisk = () => import('~/pages/broker-portal/BrokerRisk');
const InsuredAssignmentDashboard = () => import('~/pages/broker-portal/InsuredAssignmentDashboard');
const Home = () => import('~/pages/Home');
const InsuredDashboard = () => import('~/pages/insured-portal/InsuredDashboard');
const InsuredRisk = () => import('~/pages/insured-portal/InsuredRisk');
const FacilityManager = () => import('~/pages/broker-portal/FacilityManager');
const ForgotPassword = () => import('~/pages/ForgotPassword');
const Login = () => import('~/pages/Login');
const Notifications = () => import('~/pages/Notifications');
const Reports = () => import('~/pages/Reports');
const BrokerAnalytics = () => import('~/pages/broker-portal/BrokerAnalytics');
const InsuredAnalytics = () => import('~/pages/insured-portal/InsuredAnalytics');
const ResetPasswordForm = () => import('~/pages/ResetPassword');
const UpdateExpiredPasswordForm = () => import('~/pages/ExpiredPassword');
const UnauthorisedPage = () => import('~/pages/UnauthorisedPage');
const ContactManagement = () => import('~/pages/ContactManagement');
const EventsDashboard = () => import('~/pages/EventsDashboard');
const EventsView = () => import('~/pages/EventsView');
const TasksView = () => import('~/pages/TasksView');
const BasicTasksDashboard = () => import('~/pages/BasicTasksDashboard');

export default [
    {
        path: '/home',
        name: 'home',
        meta: {
            layout: 'standard'
        },
        component: Home
    },
    {
        path: '/login',
        alias: '/',
        name: 'login',
        meta: {
            layout: 'login'
        },
        component: Login,
    },
    {
        path: '/forgot-password',
        name: 'forgot-password',
        component: ForgotPassword,
        meta: {
            layout: 'login'
        }
    },
    {
        path: '/reset-password/:token',
        name: 'reset-password-form',
        component: ResetPasswordForm,
        meta: {
            layout: 'login'
        }
    },
    {
        path: '/update-expired-password',
        name: 'update-expired-password-form',
        component: UpdateExpiredPasswordForm,
        meta: {
            layout: 'login'
        }
    },
    {
        path: '/agent/dashboard',
        name: 'broker-dashboard',
        meta: {
            layout: 'broker'
        },
        component: BrokerDashboard
    },
    {
        path: '/agent/policy/:id/:action?',
        name: 'broker-risk',
        meta: {
            layout: 'broker'
        },
        component: BrokerRisk
    },
    {
        path: '/agent/facility-manager',
        name: 'facility-manager',
        meta: {
            layout: 'broker'
        },
        component: FacilityManager
    },
    {
        path: '/agent/reports',
        name: 'agent-reports',
        meta: {
            layout: 'broker'
        },
        component: Reports
    },
    {
        path: '/agent/analytics',
        name: 'broker-analytics',
        meta: {
            layout: 'broker'
        },
        component: BrokerAnalytics
    },
    {
        path: '/agent/policy/:id/amendment-entry/:amendmentId?',
        name: 'broker-amendment-entry',
        meta: {
            layout: 'broker'
        },
        component: BrokerAmendmentEntryPage
    },
    {
        path: '/agent/insured-assignment',
        name: 'insured-assignment',
        meta: {
            layout: 'broker'
        },
        component: InsuredAssignmentDashboard,
    },
    {
        path: '/agent/company-manager',
        name: 'broker-company-manager',
        meta: {
            layout: 'broker'
        },
        component: ContactManagement
    },
    {
        path: '/insured/dashboard',
        name: 'insured-dashboard',
        meta: {
            layout: 'insured'
        },
        component: InsuredDashboard,
    },
    {
        path: '/insured/company-manager',
        name: 'insured-company-manager',
        meta: {
            layout: 'insured'
        },
        component: ContactManagement
    },
    {
        path: '/insured/policy/:id',
        name: 'insured-risk',
        meta: {
            layout: 'insured'
        },
        component: InsuredRisk
    },
    {
        path: '/insured/reports',
        name: 'insured-reports',
        meta: {
            layout: 'insured'
        },
        component: Reports
    },
    {
        path: '/insured/analytics',
        name: 'insured-analytics',
        meta: {
            layout: 'insured'
        },
        component: InsuredAnalytics
    },
    {
        path: '/unauthorised',
        name: 'unauthorised',
        component: UnauthorisedPage
    },
    {
        path: '/basic/tasks/dashboard',
        name: 'basic-tasks-dashboard',
        meta: {
            layout: 'standard',
        },
        component: BasicTasksDashboard
    },
];
